module.exports = __webpack_public_path__ + "static/w-ugi-ce65847956afbe1c794c3dffa34ce8ab.jpeg";